import { getChatGPTRelatedTopics } from "../../../api/openai-api";
import { TypeHierarchyNode } from "../../nodes/hierarchy-node/hierarchy-node.model";
import { TypeTopicNode } from "../../nodes/topic-node/topic-node.model";


export const generateSubtopics = async (
  topicNode: TypeTopicNode,
  existingSubtopics?: string[],
) => {
  // const randNTopics = Math.floor(Math.random() * 2) + 1; // 1-2 subtopics
  const nTopics = 3;
  if (existingSubtopics && existingSubtopics.length > 0) {
    return await getChatGPTRelatedTopics(
      `${topicNode.data.state.topic}. Don't use these existing subtopics: ${existingSubtopics.join(', ')}.`,
      nTopics,
    );
  }
  return await getChatGPTRelatedTopics(
    topicNode.data.state.topic ?? '',
    nTopics,
  );
}
